import React from 'react';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
export var IconWithLabel = function (_a) {
    var icon = _a.icon, label = _a.label, dataTestId = _a.dataTestId;
    return (React.createElement(Row, { flex: 1, gridGap: "S200", dataTestId: dataTestId || '' },
        React.createElement(Col, null, icon),
        React.createElement(Text, { color: "neutral70", fontSize: 'T100' }, label)));
};
